import { ArticleHeading4, UIText2, UIHeading5, TooltipDesktop } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';
import React from 'react';

import styles from './Vas.css';
import { SUPPORT_LINK } from '../../../constants/links';
import { IVas } from '../../../types/offers';

type TProps = {
  items: IVas[];
  name: string;
  icon: React.ReactNode;
  bet?: string | number;
};

export const Vas: React.FC<TProps> = ({ items, name, icon, bet }) => {
  return (
    <TooltipDesktop
      theme="white"
      placement="top-end"
      title={
        <div className={styles['container']} data-name="VasInfo">
          <ArticleHeading4>Действуют услуги</ArticleHeading4>
          {items.map(vas => (
            <div key={`vas-${vas.type}`} className={styles['row']}>
              <UIHeading5 color="text-warning-default" fontWeight="bold">
                {vas.name}
              </UIHeading5>
              <UIText2>{vas.description}</UIText2>
            </div>
          ))}
          <div className={styles['button']}>
            <a href={SUPPORT_LINK} target="_blank" rel="noreferrer">
              <UIText2 color="text-main-default">Узнать подробнее</UIText2>
            </a>
          </div>
        </div>
      }
    >
      <div className={styles['inner']} data-name="Vas">
        {icon}
        <UIHeading5 color="text-warning-default">{name}</UIHeading5>
        {bet ? (
          <UIHeading5 color="text-warning-default">+&nbsp;{numberToPrettyString(Number(bet))}&nbsp;₽</UIHeading5>
        ) : null}
      </div>
    </TooltipDesktop>
  );
};
